/**
 * Query parameter naming the page the freemium sign-up flow (`/dashboard/sign-up/*`) should end
 * on, instead of the dashboard (PLT-7567). The supplier-trial campaign link sends a logged-out
 * reader to the sign-up page's sign-up tab with it set to the link itself, so that whichever way
 * they get in — logging in, signing up by email, or with Google or Microsoft — they come back to
 * the link, which then picks their page.
 */
export const DMA_ONBOARDING_NEXT_URL_PARAM = 'nextUrl';

const MAX_NEXT_URL_LENGTH = 512;

// `/go/<slug>`, optionally with a query string. Neither part admits `/`, `\`, `:` or `#`, so a
// value that matches can only be a path on this origin.
const DMA_ONBOARDING_NEXT_URL_PATTERN = /^\/go\/[a-z0-9-]+(\?[\w\-.~%&=+]*)?$/;

/**
 * Whether `value` may be used as the sign-up flow's next URL.
 *
 * The value travels in the query string through every step, and through the verification email
 * the backend sends, so anyone can put anything in it. Following an arbitrary value would be the
 * open redirect pen test PLT-4719 found on `/login-redirect`. Only the platform's own `/go/…`
 * click-time resolvers are accepted, which is all the flow needs. Checked on both sides: by the
 * UI before following the value, and by the API before writing it into the email link.
 */
export function isDmaOnboardingNextUrl(value: string): boolean {
  return value.length <= MAX_NEXT_URL_LENGTH && DMA_ONBOARDING_NEXT_URL_PATTERN.test(value);
}
